import { z } from "zod";

export const panelCreationSchema = z.object({
  // Panel Info Section
  panelName: z
    .string()
    .min(3, "Panel name must be at least 3 characters")
    .max(200, "Panel name is too long"),
  panelStatus: z.enum(["Active", "Closed"], {
    errorMap: () => ({ message: "Please select a valid panel status" }),
  }),
  panelId: z
    .string()
    .min(1, "Panel ID is required")
    .max(50, "Panel ID is too long"),
  panelType: z
    .enum(
      [
        "Community",
        "Joint Community (2 Communities)",
        "Joint Community (3 Communities)",
        "FEMA",
      ],
      {
        errorMap: () => ({ message: "Please select a valid panel type" }),
      }
    )
    .optional()
    .or(z.literal("")),
  femaRegion: z
    .enum(
      [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII",
      ],
      {
        errorMap: () => ({ message: "Please select a valid FEMA region" }),
      }
    )
    .optional()
    .or(z.literal("")),
  panelRequestDate: z.string().optional().or(z.literal("")),

  // Summary Section
  panelConvened: z.string().optional().or(z.literal("")),
  requestSummary: z
    .string()
    .max(5000, "Request summary is too long")
    .optional()
    .or(z.literal("")),
  packageLinkUrl: z
    .string()
    .url("Invalid URL format")
    .optional()
    .or(z.literal("")),
  packageLinkText: z
    .string()
    .max(200, "Link text is too long")
    .optional()
    .or(z.literal("")),

  // Decision Section
  panelDecisionDate: z.string().optional().or(z.literal("")),
  decisionSummary: z
    .string()
    .max(5000, "Decision summary is too long")
    .optional()
    .or(z.literal("")),
  reportLinkUrl: z
    .string()
    .url("Invalid URL format")
    .optional()
    .or(z.literal("")),
  reportLinkText: z
    .string()
    .max(200, "Link text is too long")
    .optional()
    .or(z.literal("")),

  // Final Determination Section
  finalDeterminationDate: z.string().optional().or(z.literal("")),
  femaFinalDeterminationSummary: z
    .string()
    .max(5000, "Summary is too long")
    .optional()
    .or(z.literal("")),

  // Shortlist Filters Section
  excludeCountry: z.string().default("United States"),
  excludeState: z.string().optional().or(z.literal("")),
  shortlistExpertise: z.array(z.string()).default([]),
  shortlistApproved: z.string().optional().or(z.literal("")),
  shortlistEmailNotified: z
    .string()
    .max(500, "Email notification text is too long")
    .optional()
    .or(z.literal("")),

  // Review Dates Section
  cadreMemberResponseDate: z.string().optional().or(z.literal("")),
  repSelectionDate: z.string().optional().or(z.literal("")),

  // Published checkbox
  isPublished: z.boolean().default(false),

  // Additional optional fields
  deadline: z.string().optional(),
  createdBy: z.number().optional(),
  createdDate: z.string().optional(),
});

export const panelCreationDefaultValues = {
  // Panel Info Section
  panelName: "",
  panelStatus: "Active",
  panelId: "",
  panelType: "",
  femaRegion: "",
  panelRequestDate: "",

  // Summary Section
  panelConvened: "",
  requestSummary: "",
  packageLinkUrl: "",
  packageLinkText: "",

  // Decision Section
  panelDecisionDate: "",
  decisionSummary: "",
  reportLinkUrl: "",
  reportLinkText: "",

  // Final Determination Section
  finalDeterminationDate: "",
  femaFinalDeterminationSummary: "",

  // Shortlist Filters Section
  excludeCountry: "United States",
  excludeState: "",
  shortlistExpertise: [],
  shortlistApproved: "",
  shortlistEmailNotified: "",

  // Review Dates Section
  cadreMemberResponseDate: "",
  repSelectionDate: "",

  // Published checkbox
  isPublished: false,

  // Additional optional fields
  deadline: "",
  createdBy: null,
  createdDate: new Date().toISOString().split("T")[0],
};
